<template>
  <div
    class="flex h-full w-full flex-col items-center justify-center space-y-2"
    data-cy="workflow-content"
  >
    <icon-empty-template />
    <lf-h3>{{ $t("BORROWER_PLATFORM.SET_WFB_STAGES") }}</lf-h3>
    <div class="flex items-center space-x-1">
      <span>{{ $t("BORROWER_PLATFORM.STAGES_SOURCE") }}</span>
      <lf-link
        :href="workflowBuilderLink"
        open-in-new-tab
        :underlined="false"
        :disabled="!workflowBuilderTemplateId"
      >
        {{ $t("COMMON.WORKFLOW_BUILDER") }}
      </lf-link>
      <span>{{ $t("COMMON.TEMPLATE") }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { TabType } from "@/models/borrowerPlatformTemplates";
import { useBorrowerPlatformTemplateBuilderStore } from "@/stores/borrowerPlatformTemplates";

import IconEmptyTemplate from "@/components/icons/borrowerPlatform/borrowerTabs/IconEmptyTemplate.vue";
import LfLink from "@/components/ui/LfLink.vue";

const borrowerPlatformTemplateStore = useBorrowerPlatformTemplateBuilderStore();

const activeTab = computed(() => {
  return borrowerPlatformTemplateStore.activeBorrowerPlatformTemplate?.content.tabs?.find(
    (tab) => tab.id === borrowerPlatformTemplateStore.selectedTabId
  );
});

const workflowBuilderTemplateId = computed(() => {
  return activeTab.value?.type === TabType.WORKFLOW
    ? activeTab.value?.workflow_template_ids?.[0]
    : undefined;
});

const workflowBuilderLink = computed(() => {
  return `/workflow-builder/${workflowBuilderTemplateId.value}`;
});
</script>
